import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _aea7636a = () => interopDefault(import('../pages/about-us/index.vue' /* webpackChunkName: "pages/about-us/index" */))
const _be9dc5d0 = () => interopDefault(import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _2161b8d6 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _0cf2dc78 = () => interopDefault(import('../pages/billing/index.vue' /* webpackChunkName: "pages/billing/index" */))
const _d9025900 = () => interopDefault(import('../pages/contacts/index.vue' /* webpackChunkName: "pages/contacts/index" */))
const _72270b1d = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _e9bed37e = () => interopDefault(import('../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _5d17a56c = () => interopDefault(import('../pages/my-organizations/index.vue' /* webpackChunkName: "pages/my-organizations/index" */))
const _2cb262c8 = () => interopDefault(import('../pages/onboarding/index.vue' /* webpackChunkName: "pages/onboarding/index" */))
const _4aa3b436 = () => interopDefault(import('../pages/open-main/index.vue' /* webpackChunkName: "pages/open-main/index" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _8d97ccfc = () => interopDefault(import('../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _84c92402 = () => interopDefault(import('../pages/test/index.vue' /* webpackChunkName: "pages/test/index" */))
const _bfe4a02a = () => interopDefault(import('../pages/admin/Acts.vue' /* webpackChunkName: "pages/admin/Acts" */))
const _401deee1 = () => interopDefault(import('../pages/admin/Balances.vue' /* webpackChunkName: "pages/admin/Balances" */))
const _03060cde = () => interopDefault(import('../pages/admin/Documents.vue' /* webpackChunkName: "pages/admin/Documents" */))
const _b665b5a0 = () => interopDefault(import('../pages/admin/Invoices.vue' /* webpackChunkName: "pages/admin/Invoices" */))
const _dc696e74 = () => interopDefault(import('../pages/admin/Organizations.vue' /* webpackChunkName: "pages/admin/Organizations" */))
const _8150d412 = () => interopDefault(import('../pages/admin/Payments.vue' /* webpackChunkName: "pages/admin/Payments" */))
const _64721724 = () => interopDefault(import('../pages/admin/ReconciliationActs.vue' /* webpackChunkName: "pages/admin/ReconciliationActs" */))
const _068ee416 = () => interopDefault(import('../pages/admin/Tariffs.vue' /* webpackChunkName: "pages/admin/Tariffs" */))
const _2a678d2b = () => interopDefault(import('../pages/admin/TaxBills.vue' /* webpackChunkName: "pages/admin/TaxBills" */))
const _cc6d5642 = () => interopDefault(import('../pages/admin/Templates.vue' /* webpackChunkName: "pages/admin/Templates" */))
const _5d8d172e = () => interopDefault(import('../pages/admin/Users.vue' /* webpackChunkName: "pages/admin/Users" */))
const _73033c71 = () => interopDefault(import('../pages/documents/archive.vue' /* webpackChunkName: "pages/documents/archive" */))
const _75d85960 = () => interopDefault(import('../pages/documents/create/index.vue' /* webpackChunkName: "pages/documents/create/index" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _10b644d5 = () => interopDefault(import('../pages/bulk-signature/_id/index.vue' /* webpackChunkName: "pages/bulk-signature/_id/index" */))
const _915aaea8 = () => interopDefault(import('../pages/documents/_id/index.vue' /* webpackChunkName: "pages/documents/_id/index" */))
const _46e812d4 = () => interopDefault(import('../pages/my-organizations/_id.vue' /* webpackChunkName: "pages/my-organizations/_id" */))
const _4d463c5c = () => interopDefault(import('../pages/my-organizations/_id/api-keys.vue' /* webpackChunkName: "pages/my-organizations/_id/api-keys" */))
const _82f03f80 = () => interopDefault(import('../pages/my-organizations/_id/billing.vue' /* webpackChunkName: "pages/my-organizations/_id/billing" */))
const _0558f3aa = () => interopDefault(import('../pages/my-organizations/_id/integrations.vue' /* webpackChunkName: "pages/my-organizations/_id/integrations" */))
const _19f0ead6 = () => interopDefault(import('../pages/my-organizations/_id/routes.vue' /* webpackChunkName: "pages/my-organizations/_id/routes" */))
const _ec700ba4 = () => interopDefault(import('../pages/my-organizations/_id/settings.vue' /* webpackChunkName: "pages/my-organizations/_id/settings" */))
const _5e1bf6e6 = () => interopDefault(import('../pages/my-organizations/_id/users.vue' /* webpackChunkName: "pages/my-organizations/_id/users" */))
const _2c53f122 = () => interopDefault(import('../pages/open/_id/index.vue' /* webpackChunkName: "pages/open/_id/index" */))
const _9c941ed6 = () => interopDefault(import('../pages/show/_id/index.vue' /* webpackChunkName: "pages/show/_id/index" */))
const _64b3ae9e = () => interopDefault(import('../pages/tags/_id/index.vue' /* webpackChunkName: "pages/tags/_id/index" */))
const _44feb926 = () => interopDefault(import('../pages/templates/_id/index.vue' /* webpackChunkName: "pages/templates/_id/index" */))
const _abde09c8 = () => interopDefault(import('../pages/widget/_id/index.vue' /* webpackChunkName: "pages/widget/_id/index" */))
const _a3d838ba = () => interopDefault(import('../pages/documents/_id/edit/index.vue' /* webpackChunkName: "pages/documents/_id/edit/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _aea7636a,
    name: "about-us"
  }, {
    path: "/admin",
    component: _be9dc5d0,
    name: "admin"
  }, {
    path: "/auth",
    component: _2161b8d6,
    name: "auth"
  }, {
    path: "/billing",
    component: _0cf2dc78,
    name: "billing"
  }, {
    path: "/contacts",
    component: _d9025900,
    name: "contacts"
  }, {
    path: "/dashboard",
    component: _72270b1d,
    name: "dashboard"
  }, {
    path: "/documents",
    component: _e9bed37e,
    name: "documents"
  }, {
    path: "/my-organizations",
    component: _5d17a56c,
    name: "my-organizations"
  }, {
    path: "/onboarding",
    component: _2cb262c8,
    name: "onboarding"
  }, {
    path: "/open-main",
    component: _4aa3b436,
    name: "open-main"
  }, {
    path: "/profile",
    component: _4bb7511c,
    name: "profile"
  }, {
    path: "/templates",
    component: _8d97ccfc,
    name: "templates"
  }, {
    path: "/test",
    component: _84c92402,
    name: "test"
  }, {
    path: "/admin/Acts",
    component: _bfe4a02a,
    name: "admin-Acts"
  }, {
    path: "/admin/Balances",
    component: _401deee1,
    name: "admin-Balances"
  }, {
    path: "/admin/Documents",
    component: _03060cde,
    name: "admin-Documents"
  }, {
    path: "/admin/Invoices",
    component: _b665b5a0,
    name: "admin-Invoices"
  }, {
    path: "/admin/Organizations",
    component: _dc696e74,
    name: "admin-Organizations"
  }, {
    path: "/admin/Payments",
    component: _8150d412,
    name: "admin-Payments"
  }, {
    path: "/admin/ReconciliationActs",
    component: _64721724,
    name: "admin-ReconciliationActs"
  }, {
    path: "/admin/Tariffs",
    component: _068ee416,
    name: "admin-Tariffs"
  }, {
    path: "/admin/TaxBills",
    component: _2a678d2b,
    name: "admin-TaxBills"
  }, {
    path: "/admin/Templates",
    component: _cc6d5642,
    name: "admin-Templates"
  }, {
    path: "/admin/Users",
    component: _5d8d172e,
    name: "admin-Users"
  }, {
    path: "/documents/archive",
    component: _73033c71,
    name: "documents-archive"
  }, {
    path: "/documents/create",
    component: _75d85960,
    name: "documents-create"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/bulk-signature/:id",
    component: _10b644d5,
    name: "bulk-signature-id"
  }, {
    path: "/documents/:id",
    component: _915aaea8,
    name: "documents-id"
  }, {
    path: "/my-organizations/:id?",
    component: _46e812d4,
    name: "my-organizations-id",
    children: [{
      path: "api-keys",
      component: _4d463c5c,
      name: "my-organizations-id-api-keys"
    }, {
      path: "billing",
      component: _82f03f80,
      name: "my-organizations-id-billing"
    }, {
      path: "integrations",
      component: _0558f3aa,
      name: "my-organizations-id-integrations"
    }, {
      path: "routes",
      component: _19f0ead6,
      name: "my-organizations-id-routes"
    }, {
      path: "settings",
      component: _ec700ba4,
      name: "my-organizations-id-settings"
    }, {
      path: "users",
      component: _5e1bf6e6,
      name: "my-organizations-id-users"
    }]
  }, {
    path: "/open/:id",
    component: _2c53f122,
    name: "open-id"
  }, {
    path: "/show/:id",
    component: _9c941ed6,
    name: "show-id"
  }, {
    path: "/tags/:id",
    component: _64b3ae9e,
    name: "tags-id"
  }, {
    path: "/templates/:id",
    component: _44feb926,
    name: "templates-id"
  }, {
    path: "/widget/:id",
    component: _abde09c8,
    name: "widget-id"
  }, {
    path: "/documents/:id/edit",
    component: _a3d838ba,
    name: "documents-id-edit"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
